import { render, staticRenderFns } from "./AudioBlockVoorbeeld.vue?vue&type=template&id=64616252&scoped=true&"
import script from "./AudioBlockVoorbeeld.vue?vue&type=script&lang=js&"
export * from "./AudioBlockVoorbeeld.vue?vue&type=script&lang=js&"
import style0 from "./AudioBlockVoorbeeld.vue?vue&type=style&index=0&id=64616252&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64616252",
  null
  
)

export default component.exports